import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NotificationProvider } from '@app/containers/NotificationProvider/NotificationProvider';
import EventSearch from '@app/containers/EventSearch/EventSearch';

const eventListContainer = document.getElementById('event-list');
class App extends Component {
	render = () => (
		<NotificationProvider>
			{eventListContainer &&
				ReactDOM.createPortal(
					// eslint-disable-next-line no-undef
					<EventSearch searchStateObject={searchStateObject} />,
					eventListContainer,
				)}
		</NotificationProvider>
	);
}

ReactDOM.render(<App />, eventListContainer);
